module.exports = __webpack_public_path__ + "img/mainLogo-small.fc13b701.png";